import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../../features/B1/settings-layout';

/** Settings layout (lane B1): title + lead + tab bar, then <Outlet/> for the tab (each tab is owned by its lane). */
export const Route = createFileRoute('/_app/settings')({
  component: SettingsLayout,
});
